var map = {
  "./pt.po": [
    "2158",
    [
      739
    ]
  ],
  "./es.po": [
    "3418",
    [
      495
    ]
  ],
  "./en.po": [
    "2317",
    [
      446
    ]
  ],
  "./da.po": [
    "9349",
    [
      262
    ]
  ],
  "./fr.po": [
    "654",
    [
      731
    ]
  ],
  "./it.po": [
    "8711",
    [
      180
    ]
  ],
  "./de.po": [
    "4105",
    [
      210
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 2981;
module.exports = __rspack_async_context;
